/**
 * De lijstquery van werkplek v6 op één plek (sessie 53). De lijst en de
 * knop "Akkoord en verwerk" in het midden abonneren op dezelfde sleutel:
 * de huidige map, kanaaltegel en zoekterm van de lijst.
 */
import { v6Api, type Kanaal, type Map as MapNaam } from "./api";
import { v6Sleutels } from "./sleutels";

export interface LijstFilter {
  map: MapNaam;
  kanaal: Kanaal | null;
  /** Leeg = niet zoeken. */
  zoek: string;
}

/** Waar de lijst mee begint: map Open, geen tegel, geen zoekterm. */
export const BEGIN_FILTER: LijstFilter = { map: "open", kanaal: null, zoek: "" };

export function lijstSleutel(f: LijstFilter) {
  return [...v6Sleutels.lijst, f.map, f.kanaal, f.zoek] as const;
}

export function lijstQuery(f: LijstFilter) {
  return {
    queryKey: lijstSleutel(f),
    queryFn: () => v6Api.lijst({ map: f.map, kanaal: f.kanaal, zoek: f.zoek || null }),
  };
}
